import { BAND_TYPE } from '../../constants/bandConstants';
import getProgramMovieEpisodeChannel from './getProgramMovieEpisodeChannel';
/**
 * 띠 타입, 요청 URL, 응답값으로부터 포스터 이미지를 가져옵니다.
 *
 * @param bandType
 * @param bandApiUrl
 * @param itemResponse
 */
var getThumbnailUrl = function (bandType, bandApiUrl, itemResponse) {
    var _a;
    var thumbnailUrl = '';
    switch (bandType) {
        case BAND_TYPE.PORT:
        case BAND_TYPE.SEARCH_RECOMMEND_PORT:
        case BAND_TYPE.LIST_PORT:
        case BAND_TYPE.LAND:
        case BAND_TYPE.PRANK:
        case BAND_TYPE.EPI: {
            var _b = getProgramMovieEpisodeChannel(bandApiUrl, itemResponse), program = _b.program, movie = _b.movie, episode = _b.episode;
            if (movie) {
                var image = movie.image;
                var images = image.reduce(function (images, image) {
                    // eslint-disable-next-line no-param-reassign
                    images[image.code] = image.url;
                    return images;
                }, {});
                var thumbnailUrls = [];
                var CAIM2400 = images.CAIM2400, CAIM2500 = images.CAIM2500, CAIM0400 = images.CAIM0400;
                if (CAIM2400 || CAIM2500) {
                    if (CAIM2400) {
                        thumbnailUrls.push(CAIM2400);
                    }
                    if (CAIM2500) {
                        thumbnailUrls.push(CAIM2500);
                    }
                    thumbnailUrl = thumbnailUrls[Math.floor(Math.random() * thumbnailUrls.length)];
                }
                else if (CAIM0400) {
                    thumbnailUrl = CAIM0400;
                }
            }
            else if (episode && bandType === BAND_TYPE.EPI) {
                var image = episode.image;
                var images = image.reduce(function (images, image) {
                    // eslint-disable-next-line no-param-reassign
                    images[image.code] = image.url;
                    return images;
                }, {});
                var CAIE0400 = images.CAIE0400, CAIP0400 = images.CAIP0400, CAIP0500 = images.CAIP0500, CAIP0200 = images.CAIP0200, CAIP2100 = images.CAIP2100, CAIP2200 = images.CAIP2200, CAIC1500 = images.CAIC1500;
                if (CAIE0400) {
                    thumbnailUrl = CAIE0400;
                }
                else if (CAIP0400) {
                    thumbnailUrl = CAIP0400;
                }
                else if (CAIP0500) {
                    thumbnailUrl = CAIP0500;
                }
                else if (CAIP0200) {
                    thumbnailUrl = CAIP0200;
                }
                else if (CAIP2100) {
                    thumbnailUrl = CAIP2100;
                }
                else if (CAIP2200) {
                    thumbnailUrl = CAIP2200;
                }
                else if (CAIC1500) {
                    thumbnailUrl = CAIC1500;
                }
            }
            else if (program) {
                var image = program.image;
                var images = image.reduce(function (images, image) {
                    // eslint-disable-next-line no-param-reassign
                    images[image.code] = image.url;
                    return images;
                }, {});
                var CAIP0400 = images.CAIP0400, CAIP0500 = images.CAIP0500, CAIP0200 = images.CAIP0200, CAIC1500 = images.CAIC1500;
                thumbnailUrl = CAIP0400 || CAIP0500 || CAIP0200 || CAIC1500;
            }
            break;
        }
        case BAND_TYPE.BAN1:
        case BAND_TYPE.BAN2:
        case BAND_TYPE.BAN3: {
            // TODO: HARD_CODING ... ?
            var highlightResult = itemResponse;
            thumbnailUrl = (_a = highlightResult.tag_mapping_image_url) !== null && _a !== void 0 ? _a : '';
            break;
        }
        case BAND_TYPE.CHA: {
            var logoImg2 = itemResponse.logo_img2;
            thumbnailUrl = logoImg2;
            break;
        }
        case BAND_TYPE.META_EPI: {
            var movie = getProgramMovieEpisodeChannel(bandApiUrl, itemResponse).movie;
            if (movie) {
                thumbnailUrl = itemResponse.image;
            }
            else {
                thumbnailUrl = itemResponse.image;
            }
            break;
        }
        default:
    }
    return thumbnailUrl;
};
export default getThumbnailUrl;
